export default "__VITE_ASSET__D7GZQit7__"